// ルーム管理画面のスクリプト

// 動作が確認できていない
// TODO: エラー履歴クリアボタンを実装する際に確認する
// // エラー履歴を全てクリア
// $(document).on ('click', '#clear-error-history-btn', () => {
//   if (confirm($(this).data('confirm'))) {
//     path = $(this).data('path')
//     console.log(path)
//     if (path != null) {
//       $.ajax({
//         url: path,
//         type: 'DELETE',
//         dataType: 'script',
//         success: (data, status, xhr) => {
//           console.log("clear MachineErrorHistory")
//         },
//         error: (data, status, xhr) => {
//           console.log("failed to clear MachineErrorHistory")
//         }
//       })
//     }
//   }
// })

// #################################################
// ### イベント登録
// #################################################

switch_radio_status = (radio) => {
  $('[name="radios"]').each((index, r) => {
    if (r.getAttribute('active') == "true") {
      r.removeAttribute('active')
      r.removeAttribute('checked')
      return false
    }
  })
  selected_td = $('.radio-tr.table-info')
  if (selected_td.length > 0) {
    selected_td.removeClass('table-info')
  }
    
  console.log(radio)
  radio.attr('active', 'true')
  radio.attr('checked', 'true')
  radio.closest('.radio-tr').addClass('table-info')
}

change_course_duration_area_visibility = (is_dry) => {
  if (is_dry){
    $('#execute-course-duration-selector').prop('disabled', false)
    $('#course-duration-select-area').css('display', 'block')
  } else {
    $('#execute-course-duration-selector').prop('disabled', true)
    $('#course-duration-select-area').css('display', 'none')
  }
}

$(document).on('click', '.radio-tr', (e) => {
  radio = $(e.currentTarget).find('.machine-control-radio')
  if (radio.length > 0) {
    switch_radio_status(radio)
  }
})

$(document).on('change', '#execute-course-course-selector', () => {
  is_dry = $('#execute-course-course-selector').find('option:selected').data('is-dry')
  change_course_duration_area_visibility(is_dry)
})


// iOSのSafariからアクセスがあった場合 必ずリロードさせる処理
$(document).on('turbolinks:request-end', () => {
  if (/shop_monitor/.test(location.pathname)) {
    ua = navigator.userAgent.toLowerCase()
    if (/ip(hone|ad)/.test(ua) && /safari/.test(ua) && !/crios/.test(ua) && !/edge/.test(ua) && !/fxios/.test(ua)){
      location.reload()
    }
  }
})
